// src/app/core/services/storage.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly available = this.detectStorage();

  get<T>(key: string): T | null {
    if (!this.available) {
      return null;
    }
    const raw = window.localStorage.getItem(key);
    if (raw === null) {
      return null;
    }
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    if (!this.available) {
      return;
    }
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key: string): void {
    if (!this.available) {
      return;
    }
    window.localStorage.removeItem(key);
  }

  private detectStorage(): boolean {
    try {
      return typeof window !== 'undefined' && !!window.localStorage;
    } catch {
      return false;
    }
  }
}
